var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9978 10.0004H6.81784L13.4178 3.42037C13.7944 3.04376 14.006 2.53297 14.006 2.00037C14.006 1.46777 13.7944 0.956978 13.4178 0.580371C13.0412 0.203763 12.5304 -0.0078125 11.9978 -0.0078125C11.4652 -0.0078125 10.9544 0.203763 10.5778 0.580371L0.57784 10.5804C0.395758 10.7706 0.253028 10.9949 0.15784 11.2404C-0.0421965 11.7273 -0.0421965 12.2734 0.15784 12.7604C0.253028 13.0059 0.395758 13.2302 0.57784 13.4204L10.5778 23.4204C10.7638 23.6078 10.985 23.7566 11.2287 23.8582C11.4724 23.9597 11.7338 24.012 11.9978 24.012C12.2619 24.012 12.5233 23.9597 12.767 23.8582C13.0107 23.7566 13.2319 23.6078 13.4178 23.4204C13.6053 23.2344 13.7541 23.0132 13.8556 22.7695C13.9572 22.5258 14.0094 22.2644 14.0094 22.0004C14.0094 21.7363 13.9572 21.4749 13.8556 21.2312C13.7541 20.9875 13.6053 20.7663 13.4178 20.5804L6.81784 14.0004H21.9978C22.5283 14.0004 23.037 13.7897 23.4121 13.4146C23.7871 13.0395 23.9978 12.5308 23.9978 12.0004C23.9978 11.4699 23.7871 10.9612 23.4121 10.5862C23.037 10.2111 22.5283 10.0004 21.9978 10.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackDesktop);
export default __webpack_public_path__ + "static/media/back_desktop.bbdca189b08336e9f21ae4a4766cde4f.svg";
export { ForwardRef as ReactComponent };